import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Virtual, FreeMode, Keyboard, Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Divider, Typography, Link, Button } from '@mui/material';
import Grid from '@mui/material/Grid';
import TravelRequest from '../../components/navbar/travelRequest';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import { alpha } from '@mui/system';

import { GlobalTheme } from '../../theme';
import DestinationStyle from './assets/scss/destination.module.scss';
const BASE_MEDIA_URL = 'https://aaryanholidays.in/express/uploads/';

const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
};

const Carousel = () => {
    const [destinationData, setDestinationData] = useState([]);
    const videoRefs = useRef([]);
    const [swiperRef, setSwiperRef] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    const handleMouseEnter = (index) => {
        const videoElement = videoRefs.current[index];
        if (videoElement && videoElement.paused) {
            videoElement.play().catch(error => console.error('Error playing video:', error));
        }
    };

    const handleMouseLeave = (index) => {
        const videoElement = videoRefs.current[index];
        if (videoElement && videoElement.tagName === 'VIDEO' && !videoElement.paused) {
            videoElement.pause();
            videoElement.currentTime = 0;
        }
    };

    const handleCardClick = (id, continent, country, tour) => {

        navigate(`/${continent}/${country}/${tour}/itenary/${id}`);
    };
    const handlediscovCardClick = (id) => {
        navigate(`/search/TrendingPackage`);
    }


    useEffect(() => {
        const fetchData = async () => {
            try {
                const destinationsResponse = await fetch('https://aaryanholidays.in/frontend/alldestinations');
                const destinationsData = await destinationsResponse.json();
                const promotedData = destinationsData.filter(destination => destination.promote === 1);
                setDestinationData(promotedData);

                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    return (
        <Box>
            {/* {isLoading ? (
                <>
                    <Grid item xs={12} sx={{ overflow: 'hidden' }}>
                        <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginBottom: 4 }}>
                            <Skeleton variant="rectangular" animation='wave' width={200} sx={{ height: 20, mb: 3 }} />
                            <Skeleton variant="rectangular" animation='wave' width={200} sx={{ height: 10, mb: 1 }} />
                            <Skeleton variant="rectangular" animation='wave' width={400} sx={{ height: 10, mb: 1 }} />
                            <Skeleton variant="rectangular" animation='wave' width={500} sx={{ height: 10, mb: 1 }} />
                        </Box>

                        <Stack direction='row' justifyContent='space-between' flexWrap="wrap" gap={1} sx={{ overflow: 'hidden' }}>
                            {Array.from({ length: 6 }).map((_, index) => (
                                <Skeleton
                                    key={index}
                                    variant="rectangular"
                                    animation="wave"
                                    width={258}
                                    sx={{ height: 348, borderRadius: 2 }}
                                />
                            ))}
                        </Stack>
                    </Grid>
                </>
            ) : (
                <>

                </>
            )} */}
            {!isLoading && destinationData.length > 0 && (
                <Grid id={`destinationContainer${Date.now()}`} item xs={12} sx={{
                    px: { xs: 2.5, md: 0 },
                }} >
                    <Stack direction={{ md: 'row' }} justifyContent='space-between' alignItems='center' display='flex' sx={{ mb: 4 }}>
                        <Typography id={`specialHeading${Date.now()}`} component='h2' variant='h2' fontWeight={600}>Trending Packages</Typography>
                        {/* <Typography component='p' marginBottom={4}>Explore our customer favorites list of the top-selling destinations.</Typography> */}
                        <Button variant="text"
                            sx={{
                                fontWeight: 400,
                                overflow: 'hidden', // Ensures no overflow on hover
                                display: 'flex',
                                alignItems: 'center',
                                transition: 'transform 0.3s ease',
                                '&:hover .buttonContent': {
                                    transform: 'translateX(8px)', // Adjust as needed for animation distance
                                },
                                '&:hover .icon': {
                                    opacity: 1,
                                    transform: 'translateX(0)', // Slide icon in from the left
                                },
                            }}
                        >
                            <Box
                                className="buttonContent"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    transition: 'transform 0.3s ease',
                                }}
                            >
                                <Box component='span' onClick={() => handlediscovCardClick('TP')} sx={{ mr: .5 }}>Explore ALl</Box>
                                <KeyboardArrowRightOutlinedIcon
                                    className="icon"
                                    sx={{
                                        ml: 1, // Add some spacing between text and icon
                                        opacity: 0, // Initially hidden
                                        transform: 'translateX(-10px)', // Initial position off to the left
                                        transition: 'opacity 0.3s ease, transform 0.3s ease', // Smooth transition for appearance
                                    }}
                                />
                            </Box>
                        </Button>
                    </Stack>

                    <Swiper
                        keyboard={{ enabled: true }}
                        id={`trendingDestinationSwiper${Date.now()}`}
                        onSwiper={setSwiperRef}
                        // slidesPerView={3}

                        centeredSlides={false}
                        spaceBetween={50}
                        pagination={{
                            clickable: true,
                        }}
                        navigation={{
                            nextEl: '.custom-swiper-button-next',
                            prevEl: '.custom-swiper-button-prev',
                        }}
                        grabCursor={true}

                        // freeMode={true}

                        // slidesOffsetAfter={180}
                        // autoplay={{
                        //     delay: 1500,
                        //     disableOnInteraction: true,
                        // }}
                        loop={true}

                        modules={[Virtual, FreeMode, Keyboard, Pagination, Autoplay, Navigation]}

                        className={DestinationStyle.swiperContainer}
                        breakpoints={{
                            0: { slidesPerView: 1, spaceBetween: 10 },
                            600: { slidesPerView: 2, spaceBetween: 20 },
                            900: { slidesPerView: 3, spaceBetween: 40 },
                            // 1200: { slidesPerView: 3, spaceBetween: 90 },
                        }}
                        style={{
                            width: '100%',
                            position: 'relative',
                            paddingBottom: 50,

                            '& .swiper-pagination': {
                                position: 'relative',
                            }
                        }}
                    >
                        {destinationData.map((tour, index) => (
                            <SwiperSlide
                                id='destinationSlide'
                                key={index}
                                virtualIndex={index}
                                className={DestinationStyle.swiperSlideCustom}

                            >
                                <Card
                                    key={index}
                                    sx={{
                                        position: 'relative',
                                        borderRadius: 2,
                                        width: { xs: '100%', sm: 367 },
                                        height: {
                                            xs: 468,
                                            sm: 500
                                        },
                                        objectFit: 'cover',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <Box
                                        id={'destination' + tour.id}
                                        onMouseEnter={() => handleMouseEnter(index)}
                                        onMouseLeave={() => handleMouseLeave(index)}
                                        sx={{ height: 'inherit' }}
                                    >
                                        {tour.type === 'video' ? (
                                            <CardMedia
                                                id={`destinationThumbsVid${index}`}
                                                component="video"
                                                src={`${BASE_MEDIA_URL}${tour.src}`}
                                                loading='lazy'
                                                loop
                                                autoPlay
                                                muted
                                                playsInline
                                                width="100%"
                                                height="100%"
                                                ref={(el) => (videoRefs.current[index] = el)}
                                                sx={{
                                                    objectFit: 'cover',
                                                    minHeight: { xs: '468px', sm: '500px' }
                                                }}
                                            >
                                                <source src={`${BASE_MEDIA_URL}${tour.src}`} type="video/mp4" />
                                                Your browser does not support the video tag.
                                            </CardMedia>
                                        ) : (
                                            <CardMedia
                                                id={`destinationThumbsImg${index}`}
                                                component="img"
                                                src={`${BASE_MEDIA_URL}${tour.src}`}
                                                alt={tour.alt}
                                                loading='lazy'
                                                sx={{
                                                    height: { xs: '468px', sm: '500px' },
                                                    width: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        )}
                                        <CardContent id={'destinationCardContent' + tour.id}
                                            sx={{
                                                position: 'absolute',
                                                width: '100%',
                                                height: '100%',
                                                top: 0,
                                                left: 0,
                                                px: 0, py: 0
                                            }}
                                        >
                                            <Box sx={{
                                                position: 'relative',
                                                bottom: 0,
                                                left: 0,
                                                px: 2,
                                                textAlign: 'left',
                                                height: 'inherit',
                                                // width: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                flexWrap: 'wrap',
                                                justifyContent: 'flex-end',

                                                background: `linear-gradient(0deg, ${alpha(GlobalTheme.palette.common.tertiary, .7)} 30%, ${alpha(GlobalTheme.palette.common.tertiary, 0)} 70%)`,
                                                transition: 'all .4s ease',
                                                // "&:hover": {
                                                //     pt: 23,
                                                //     background: `linear-gradient(0deg, ${alpha(GlobalTheme.palette.common.tertiary, .8)} 10%, ${alpha(GlobalTheme.palette.common.tertiary, 0)} 100%)`,
                                                // }
                                            }}>
                                                <Typography component='p' variant="subtitle2" fontWeight={400} color='warning.light' gutterBottom>
                                                    {tour.tour_days}
                                                </Typography>

                                                <Typography component='p' variant="subtitle2" color='common.white' sx={{ textAlign: 'left' }} fontWeight={400}>
                                                    {truncateText(tour.thumbnail_desc, 90)}
                                                </Typography>
                                                <Typography variant='h3' component='h3' sx={{ color: GlobalTheme.palette.common.white, pr: 4 }} gutterBottom>
                                                    <span dangerouslySetInnerHTML={{ __html: tour.thumbnail_heading }} />
                                                </Typography>
                                                <Divider sx={{ backgroundColor: GlobalTheme.palette.common.white, mb: .5 }} />

                                                <Typography component='p' variant="subtitle1" color='common.white' sx={{ textAlign: 'left' }} >
                                                    INR {tour.price} <Typography component='span' fontWeight={400} variant='subtitle2'>per person</Typography>
                                                </Typography>

                                                <Stack direction='row' justifyContent='space-between' sx={{ my: 2 }} spacing={3}>
                                                    <Link
                                                        id={'btnDestination' + tour.id}
                                                        href={`/${tour.continent_name.replace(/\s+/g, '-')}/${tour.tour_type_name.replace(/\s+/g, '-')}/${tour.thumbnail_heading.replace(/\s+/g, '-')}/itenary/${tour.id}`}
                                                        variant="contained" underline="none"
                                                        // onClick={() => handleCardClick(tour.id, tour.continent_name.replace(/\s+/g, '-'), tour.tour_type_name.replace(/\s+/g, '-'), tour.thumbnail_heading.replace(/\s+/g, '-'))}
                                                        sx={{
                                                            px: 2, py: 1.5, borderRadius: 2,
                                                            color: GlobalTheme.palette.common.white,
                                                            borderColor: GlobalTheme.palette.primary.main,
                                                            backgroundColor: GlobalTheme.palette.primary.main,

                                                            '&:hover, &:focus': {
                                                                color: GlobalTheme.palette.common.black,
                                                                borderColor: GlobalTheme.palette.common.white,
                                                                backgroundColor: GlobalTheme.palette.common.white,
                                                            }
                                                        }}>
                                                        View Tour
                                                    </Link>

                                                    <TravelRequest
                                                        id={`getQutBtn${tour.thumbnail_heading.substring(0, 2).replace(/\s+/g, '')}_${tour.id}_${Date.now()}`}
                                                        variant="outlined"
                                                        size='medium'
                                                        btnLabel='Get a Quote'
                                                        sxOverrides={{
                                                            py: .625, px: 1.875, borderRadius: 2,
                                                            color: GlobalTheme.palette.common.white,
                                                            backgroundColor: 'transparent',
                                                            borderColor: GlobalTheme.palette.primary.main,

                                                            '&:hover': {
                                                                color: GlobalTheme.palette.primary.main,
                                                                backgroundColor: GlobalTheme.palette.common.white,
                                                            }

                                                        }}
                                                        selectedDestination={tour.thumbnail_heading}
                                                    />
                                                </Stack>
                                            </Box>
                                        </CardContent>
                                    </Box>
                                </Card>
                            </SwiperSlide>
                        ))}
                        {destinationData.length > 3 && (
                            <>
                                <IconButton
                                    className="custom-swiper-button-prev"
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: { xs: 5, md: 10 },
                                        transform: 'translateY(-60px)',
                                        zIndex: 10,
                                        color: GlobalTheme.palette.primary.main,
                                        backgroundColor: alpha(GlobalTheme.palette.common.white, .8),
                                        transition: 'all .3s ease-in-out',
                                        width: { xs: 40, md: 48 },
                                        height: { xs: 40, md: 48 },

                                        "&:hover, &:focus": {
                                            boxShadow: GlobalTheme.shadows[5],
                                            backgroundColor: GlobalTheme.palette.common.white,
                                            "& .MuiSvgIcon-root": {
                                                transform: 'translateX(-4px)',
                                            },
                                        }
                                    }}
                                    aria-label='Previous trending package'
                                >
                                    <KeyboardArrowLeftOutlinedIcon sx={{
                                        fontSize: { xs: 24, md: 32 },
                                        transition: 'transform 0.3s ease'
                                    }} />
                                </IconButton>

                                <IconButton
                                    className="custom-swiper-button-next"
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        right: 30,
                                        transform: 'translateY(-60px)',
                                        zIndex: 10,
                                        color: GlobalTheme.palette.primary.main,
                                        backgroundColor: alpha(GlobalTheme.palette.common.white, .8),
                                        transition: 'all .3s ease-in-out',
                                        width: { xs: 40, md: 48 },
                                        height: { xs: 40, md: 48 },

                                        "&:hover, &:focus-visible": {
                                            boxShadow: GlobalTheme.shadows[5],
                                            backgroundColor: GlobalTheme.palette.common.white,
                                            "& .MuiSvgIcon-root": {
                                                transform: 'translateX(4px)',
                                            },
                                        }
                                    }}
                                    aria-label='Next trending package'
                                >
                                    <KeyboardArrowRightOutlinedIcon sx={{
                                        fontSize: { xs: 24, md: 32 },
                                        transition: 'transform 0.3s ease'
                                    }} />
                                </IconButton>
                            </>
                        )}
                    </Swiper>
                </Grid>
            )}
        </Box >
    );
    // return (
    //     <Box>
    //         {!isLoading && destinationData.length > 0 && (
    //             <Grid id='containerDestination' item xs={12} lg={12}>
    //                 <Stack direction='row' justifyContent='space-between' alignItems='center' display='flex' sx={{ mb: 4 }}>
    //                     <Typography id="destinationHeading" component='h2' variant='h2' fontWeight={600}>
    //                         Trending Packages
    //                     </Typography>
    //                 </Stack>

    //                 <Grid container spacing={4}>
    //                     {destinationData.map((tour, index) => (
    //                         <Grid item xs={12} sm={6} md={4} key={tour.id}>
    //                             <Card
    //                                 sx={{
    //                                     position: 'relative',
    //                                     borderRadius: 2,
    //                                     height: 500,
    //                                     objectFit: 'cover',
    //                                     overflow: 'hidden'
    //                                 }}
    //                             >
    //                                 <Box
    //                                     id={'destination' + tour.id}
    //                                     onMouseEnter={() => handleMouseEnter(index)}
    //                                     onMouseLeave={() => handleMouseLeave(index)}
    //                                     sx={{ height: 'inherit' }}
    //                                 >
    //                                     {tour.type === 'video' ? (
    //                                         <CardMedia
    //                                             component="video"
    //                                             src={`${BASE_MEDIA_URL}${tour.src}`}
    //                                             loop
    //                                             autoPlay
    //                                             muted
    //                                             playsInline
    //                                             ref={(el) => (videoRefs.current[index] = el)}
    //                                             sx={{ objectFit: 'cover', height: '100%' }}
    //                                         />
    //                                     ) : (
    //                                         <CardMedia
    //                                             component="img"
    //                                             src={`${BASE_MEDIA_URL}${tour.src}`}
    //                                             alt={tour.alt}
    //                                             loading="lazy"
    //                                             sx={{ height: '100%', objectFit: 'cover' }}
    //                                         />
    //                                     )}

    //                                     <CardContent
    //                                         sx={{
    //                                             position: 'absolute',
    //                                             bottom: 0,
    //                                             left: 0,
    //                                             width: '100%',
    //                                             textAlign: 'left',
    //                                             display: 'flex',
    //                                             flexDirection: 'column',
    //                                             justifyContent: 'flex-end',
    //                                             background: `linear-gradient(0deg, ${alpha(GlobalTheme.palette.common.tertiary, 0.7)} 30%, ${alpha(GlobalTheme.palette.common.tertiary, 0)} 70%)`,
    //                                             color: 'white',
    //                                             p: 2
    //                                         }}
    //                                     >
    //                                         <Typography variant="subtitle2" fontWeight={400} color="warning.light" gutterBottom>
    //                                             {tour.tour_days}
    //                                         </Typography>

    //                                         <Typography variant="subtitle2" sx={{ color: 'white' }} fontWeight={400}>
    //                                             {truncateText(tour.banner_description, 90)}
    //                                         </Typography>

    //                                         <Typography variant="h3" sx={{ color: 'white' }} gutterBottom>
    //                                             <span dangerouslySetInnerHTML={{ __html: tour.thumbnail_heading }} />
    //                                         </Typography>

    //                                         <Divider sx={{ backgroundColor: 'white', mb: 0.5 }} />

    //                                         <Typography variant="subtitle1">
    //                                             INR {tour.price}{' '}
    //                                             <Typography component="span" fontWeight={400} variant="subtitle2">
    //                                                 per person
    //                                             </Typography>
    //                                         </Typography>

    //                                         <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }} spacing={2}>
    //                                             <Button
    //                                                 variant="contained"
    //                                                 onClick={() =>
    //                                                     handleCardClick(
    //                                                         tour.id,
    //                                                         tour.continent_name.replace(/\s+/g, '-'),
    //                                                         tour.tour_type_name.replace(/\s+/g, '-'),
    //                                                         tour.thumbnail_heading.replace(/\s+/g, '-')
    //                                                     )
    //                                                 }
    //                                                 sx={{
    //                                                     color: GlobalTheme.palette.common.black,
    //                                                     backgroundColor: GlobalTheme.palette.common.white,
    //                                                     '&:hover': {
    //                                                         backgroundColor: GlobalTheme.palette.primary.main,
    //                                                         color: 'white',
    //                                                     }
    //                                                 }}
    //                                             >
    //                                                 View Tour
    //                                             </Button>

    //                                             <Button
    //                                                 variant="outlined"
    //                                                 sx={{
    //                                                     color: 'white',
    //                                                     borderColor: 'white',
    //                                                     '&:hover': {
    //                                                         backgroundColor: GlobalTheme.palette.common.white,
    //                                                         color: GlobalTheme.palette.primary.main
    //                                                     }
    //                                                 }}
    //                                             >
    //                                                 Get A Quote
    //                                             </Button>
    //                                         </Stack>
    //                                     </CardContent>
    //                                 </Box>
    //                             </Card>
    //                         </Grid>
    //                     ))}
    //                 </Grid>
    //             </Grid>
    //         )}
    //     </Box>
    // );

};

export default Carousel;
